const tipoConversa = {

  NOTIFICACAO_DAE: 'NOTIFICACAO_DAE',
  SOLICITACAO_RETIFICACAO: 'SOLICITACAO_RETIFICACAO',
  OUVIDORIA: 'OUVIDORIA',
  NOTIFICACAO_INTERESSADO: 'NOTIFICACAO_INTERESSADO',
  SINALIZACAO_PENDENCIA: 'SINALIZACAO_PENDENCIA',
  SOLICITACAO_INFORMACAO: 'SOLICITACAO_INFORMACAO',
  NOTIFICACAO_FORMA_PAGAMENTO: 'NOTIFICACAO_FORMA_PAGAMENTO',
  NOTIFICACAO_INFRACAO: 'NOTIFICACAO_INFRACAO',
  VISTORIA_REMOTA: 'VISTORIA_REMOTA'

}

export default tipoConversa



// WEBPACK FOOTER //
// ./src/utils/tipoConversa.js